import { Grid, Modal, Box, Img, Link, Typography, Button } from "@xcorejs/ui";
import { Heading3 } from "design-system";
import { resolveSrcSet } from "utils";
import { useLayout } from "xcore";
import { Person } from "xcore/types";

type ContactDetailModalProps = {
  person: Pick<Person, "id" | "values" | "title">;
  name: string;
};

export const ContactDetailModal = ({ person, name }: ContactDetailModalProps) => {
  const { id, values: p } = person;
  const { stringify, image } = useLayout();

  const imgUrl = p.photo ? image(p.photo, { width: 190, height: 240 }) : null;
  const bigImgUrl = p.photo ? image(p.photo, { width: 190, height: 240, enlargement: 2 }) : null;
  const infoQr = p.infoQR ? image(p.infoQR, { width: 200, height: 200 }) : null;
  const bigInfoQr = p.infoQR ? image(p.infoQR, { width: 200, height: 200, enlargement: 2 }) : null;

  return (
    <Modal
      size="lg"
      paddingX={{ _: "2rem", md: "4rem" }}
      _overlay={{
        zIndex: 5,
      }}
    >
      <Grid columns={{ _: "1", md: imgUrl ? "19rem auto 20rem" : "auto 20rem" }} rows="auto" gap="3rem">
        {imgUrl && (
          <Box>
            <Img display="block" src={imgUrl} {...resolveSrcSet(imgUrl, bigImgUrl)} alt={name} loading="lazy" />
          </Box>
        )}

        <Box>
          <Heading3>{name}</Heading3>

          <Typography>{stringify(p.jobTitle)}</Typography>

          <Typography variant="p" mt="2rem">
            {p.phone && (
              <>
                <Link
                  href={"tel:" + p.phone.replace(/\s+/g, "")}
                  color="inherit"
                  border={0}
                  _hover={{ border: 0, color: "inherit" }}
                  display="flex"
                  title={p.phone}
                >
                  Tel. {p.phone}
                </Link>
              </>
            )}
            {p.email && (
              <Link
                href={"mailto:" + p.email}
                display="inline"
                maxWidth="100%"
                wordBreak="break-all"
                textOverflow="ellipsis"
                title={p.email}
              >
                {p.email}
              </Link>
            )}
          </Typography>

          {p.otherContactDetails && (
            <Typography variant="p" mt="2rem">
              {p.otherContactDetails}
            </Typography>
          )}

          <Button as="a" mt="2rem" href={`/api/robe/vcard/${id}?ref=${window.location.href}`}>
            vCard
          </Button>
        </Box>

        {infoQr && (
          <Box>
            <Img src={infoQr} {...resolveSrcSet(infoQr, bigInfoQr)} alt="QR" display="block" />
          </Box>
        )}
      </Grid>
    </Modal>
  );
};
